import Person from "./Person";

export default class Teacher extends Person {
    personID: number;
    code: string;
    bosCode: string;
    proposedLoad: number;
    actualLoad: number;
    cycleLimit?: number;
    overallLimit?: number;
    order: number;
    isUser: boolean;

    spareField1: string;
    spareField2: string;
    spareField3: string;

    constructor(data?: Partial<Teacher>) {
        super(data);
        Object.assign(this, data);
    }
}